import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Modal from 'react-modal';


import { quickAddToCart } from "../../../../../action/cart";

//Import Store
import store from '../../../../../store';

//Import Action
import { getProductBySlug } from '../../../../../action/products';

function SingleDetailDesktop(props) {
  const { dataProduct, category_slug, setColorCode } = props;
  const [modal, setModal] = useState(false);
  const [productBySlug, setProductBySlug] = useState(null);
  const product_slug = 'wzornik-kolorow-tynkow-kosbud';

  const openModal = () => {
    store.dispatch(getProductBySlug(product_slug, setProductBySlug));
    setModal(true);
  }

  const handleToCart = (e) => {
    e.preventDefault();
    if (productBySlug) {
      props.quickAddToCart(productBySlug, 1);
      setModal(false);
    }
  }
  
  const closeModal = (e) => {
    e.preventDefault();
    document.querySelector(".modal-body").style.opacity = 0;
    setModal(false);

    setTimeout(() => {
      if (document.querySelector(".sticky-header.fixed")) {
        document.querySelector(".sticky-header.fixed").style.paddingRight = 0 + "px";
      }

      document.querySelector("html").style.marginRight = 0 + "px";
      document.querySelector("html").style.marginRight = "";
      document.querySelector("html").style.overflow = "";
    }, 200);
  }

  const attr = dataProduct.attributes_items ? Object.values(dataProduct.attributes_items.attribute_1.items).find(attribute => attribute.link_selected) : '';

  return (
    <>
      <div className="skel-pro skel-detail"></div>
      <div className="product-single-details">
        <h1 className="product-title" itemProp="name">{dataProduct.product ? dataProduct.product_variant_name : dataProduct.product_name}</h1>

        {/* <div className="ratings-container" itemProp="aggregateRating" itemScope itemType="http://schema.org/AggregateRating">
          <div className="product-ratings">
            <span className="ratings" style=
              {{ width: 20 * 
                ( dataProduct.product ?
                  dataProduct.product.comments.length > 0 ? 
                    (sum(dataProduct.product.comments.map(rating => rating.comment_score)) / dataProduct.product.comments.length) 
                  : 0 
                : dataProduct.comments.length > 0 ? 
                    (sum(dataProduct.comments.map(rating => rating.comment_score)) / dataProduct.comments.length) 
                  : 0 )
              + '%' }}>
            </span>
          </div>

          <Link to="#" onClick={(e) => { e.preventDefault(); }} className="rating-link">( <span itemProp="ratingCount ratingValue">{dataProduct.product ? dataProduct.product.comments.length : dataProduct.comments.length} </span> {dataProduct.product ? dataProduct.product.comments.length === 1 ? 'opinia' : dataProduct.product.comments.length > 1 && dataProduct.product.comments.length < 5 ? 'opinie' : 'opinii' : dataProduct.comments.length === 1 ? 'opinia' : dataProduct.comments.length > 1 && dataProduct.comments.length < 5 ? 'opinie' : 'opinii'} )</Link>
        </div> */}

        <div className="product-desc pt-4">
          <div itemProp="description" dangerouslySetInnerHTML={{__html:dataProduct.product_variant_short_description ? dataProduct.product_variant_short_description : dataProduct.product_short_description}}></div>
        </div>

        {
          dataProduct.product ?
            dataProduct.product.attribute1 ?
              <div className="product-filters-container">
                <div className="mt-2">
                  <label className="text-uppercase">{dataProduct.product.attribute1.attribute_value}:</label>
                  <div className="product-single-filter">
                    <ul className="config-size-list">
                      {
                        Object.values(dataProduct.attributes_items.attribute_1.items).map(attribute => (
                          <li className={attribute.attribute_item_name === '240 mm (pióro-wpust)' ? 'col-lg-6' : (attribute.attribute_item_name === '240 mm (pióro-wpust)' && attribute.link_selected) ? `active col-lg-6` : attribute.link_selected ? `active col-lg-3` : `col-lg-3`} key={attribute.attribute_item_id}>
                            <Link to={`${process.env.PUBLIC_URL}/produkty/${dataProduct.product.category.category_slug}/${attribute.link}`}>{attribute.attribute_item_name}</Link>
                          </li>
                        ))
                      }
                    </ul>
                    <div className="row">
                      <div className="col-lg-12">
                        {(category_slug === "produkty-barwione" && (attr && attr.attribute_item_value === "kolor-tynki")) ? 
                          <input type="text" className="form-input w-100 text-center color-code" placeholder="Wpisz kod koloru ..." onChange={(e) => setColorCode(e.target.value)} />
                        : null  
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              : null
            : null
        }
        {
          category_slug === "produkty-barwione" ? 
            <div className="col-12 btn btn-sm btn-thirdy" style={{padding: '.5rem', fontWeight: '600'}} onClick={openModal}>Wybór koloru</div>
          : null
        }
        {
          dataProduct.product ?
            dataProduct.product.attribute2 ?
              <div className="product-filters-container">
                <div className="mt-2">
                  <label className="text-uppercase">{dataProduct.product.attribute2.attribute_value}:</label>
                  <div className="product-single-filter">
                    <ul className="config-size-list">
                      {
                        Object.values(dataProduct.attributes_items.attribute_2.items).map(attribute => (
                          <li className={attribute.link_selected ? "active col-lg-3" : "col-lg-3"} key={attribute.attribute_item_id}>
                            <Link to={`${process.env.PUBLIC_URL}/produkty/${dataProduct.product.category.category_slug}/${attribute.link}`}>{attribute.attribute_item_name}</Link>
                          </li>
                        ))
                      }
                    </ul>
                  </div>
                </div>
              </div>
              : null
            : null
        }

        {
          dataProduct.product ?
            dataProduct.product.attribute3 ?
              <div className="product-filters-container">
                <div className="mt-2">
                  <label className="text-uppercase">{dataProduct.product.attribute3.attribute_value}:</label>
                  <div className="product-single-filter">
                    <ul className="config-size-list">
                      {
                        Object.values(dataProduct.attributes_items.attribute_3.items).map(attribute => (
                          <li className={attribute.link_selected ? "active col-lg-3" : "col-lg-3"} key={attribute.attribute_item_id}>
                            <Link to={`${process.env.PUBLIC_URL}/produkty/${dataProduct.product.category.category_slug}/${attribute.link}`}>{attribute.attribute_item_name}</Link>
                          </li>
                        ))
                      }
                    </ul>
                  </div>
                </div>
              </div>
              : null
            : null
        }
      </div>
      <Modal
        isOpen={modal}
        onRequestClose={closeModal}
        shouldFocusAfterRender={false}
        className="shipping-popup"
        overlayClassName="cart-modal-overlay"
        closeTimeoutMS={10}
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <form onSubmit={handleToCart} style={{ marginBottom: '0' }}>
              <div className="modal-body">
                <div className="col-lg-12">
                  <div className="modal-header mb-2">
                    <h3 className="modal-title">Zamów wzornik kolorów lub umów wizytę konsultanta</h3>
                    <button type="button" className="close" onClick={closeModal} aria-label="Close">
                      <span aria-hidden="true">×</span>
                    </button>
                  </div>
                </div>
                <div className="col-lg-12 text-center">
                  <p>Kolory na ekranie mogą być niezgodne z rzeczywistym kolorem produktu.</p>
                  <div className="row align-items-center">
                    <div className="col-lg-6">Umów wizytę konsultanta<br/><a href="tel:+48531429932" className="font-semibold font-orange">+48 531 429 932</a></div>
                    <div className="col-lg-6">
                      <button type="submit" className="btn btn-primary btn-sm w-100">ZAMÓW<br/>WZORNIK</button>
                    </div>
                  </div>
                </div>
                <div className="col-lg-12 mt-2"></div>
              </div>
            </form>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default connect(null, { quickAddToCart })(SingleDetailDesktop);